// useHonestDay — returns whether today is an "honest day": the user
// logged a dose over today's taper target. While true, the app
// suppresses motivational surfaces (streak celebrations, toast nudges,
// digest celebratory framing) but NEVER suppresses support surfaces
// (urge-surf, breathe, crisis, MAT referral, hold suggestion).
//
// Inputs come from existing useApi calls in TodayScreen — this hook
// is pure: it doesn't fetch. Pass the already-resolved `todayActualMg`
// and `todayTargetMg`.
//
// Return semantics:
//   null  — data still loading (caller should not yet decide).
//   true  — over today's target with margin (suppress celebration).
//   false — at or under target (normal celebratory surfaces ok).
//
// The 10% margin avoids tipping into "honest day" on a rounding wobble
// (e.g., a 30.1 mg log against a 30 mg target shouldn't reframe the
// whole screen as a tough day). The `todayTargetMg === 0` special-case
// covers the off-curve / post-taper user — any logged dose at all is
// over target there, but a sub-threshold sliver (< 0.5 mg) shouldn't
// trip the flag (residual rounding from extract-form conversions).

export function useHonestDay(
  todayActualMg: number | null,
  todayTargetMg: number | null,
): boolean | null {
  if (todayActualMg == null || todayTargetMg == null) return null;
  if (todayTargetMg === 0) return todayActualMg > 0.5;
  return todayActualMg > todayTargetMg * 1.1;
}
